import { render } from "./GamePlayground.vue?vue&type=template&id=480e2f34&scoped=true"
import script from "./GamePlayground.js?vue&type=script&lang=js"
export * from "./GamePlayground.js?vue&type=script&lang=js"

import "./GamePlayground.scss?vue&type=style&index=0&id=480e2f34&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480e2f34"]])

export default __exports__